import { DragDropModule } from "@angular/cdk/drag-drop";
import { LayoutModule } from "@angular/cdk/layout";
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatGridListModule } from "@angular/material/grid-list";
import { TooltipModule, TooltipOptions } from '@cloudfactorydk/ng2-tooltip-directive';
import { IonicModule } from "@ionic/angular";
import { LottieComponent } from 'ngx-lottie';
import { ThumbnailPdfComponent } from "../../components/thumbnail-pdf/thumbnail-pdf.component";
import { PipesModule } from "../../pipes/pipes.module";
import { QtyStepperModule } from "../../shared/shop/qty-stepper/qty-stepper.module";
import { BindingOptionsModule } from "../binding-options/binding-options.module";
import { DefaultTooltipOptions } from '../default-tooltip-options';
import { FileSegmentOptionsComponent } from "../file-segment-options/file-segment-options.component";
import { FileComponent } from "../file/file.component";
import { LaminationOptionsComponent } from "../lamination-options/lamination-options.component";
import { OptionsButtonModule } from "../options-button/options-button.module";
import { TooltipInfoNumBlankPagesComponent } from "../tooltip-info-components/tooltip-info-num-blank-pages/tooltip-info-num-blank-pages.component";
import { FilesContainerComponent } from "./files-container.component";

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DragDropModule,
    PipesModule,
    MatGridListModule,
    LayoutModule,
    ThumbnailPdfComponent,
    LottieComponent,
    OptionsButtonModule,
    QtyStepperModule,
    LaminationOptionsComponent,
    TooltipModule.forRoot(DefaultTooltipOptions as TooltipOptions),
    BindingOptionsModule,
  ],
  declarations: [
    FilesContainerComponent,
    FileSegmentOptionsComponent,
    FileComponent,
    TooltipInfoNumBlankPagesComponent
  ],
  exports: [FilesContainerComponent],
})
export class FilesContainerModule { }
